import { render, staticRenderFns } from "./change-log.vue?vue&type=template&id=449a7e92&"
import script from "./change-log.vue?vue&type=script&lang=ts&"
export * from "./change-log.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports